
import { addProduct } from '@/lib/supabase/products';
import type { SaveResult, CreateProductParams } from './types';
import type { Product } from '@/lib/supabase/products/types';

export async function createProduct({
  productData,
  shopId,
  organizationId
}: CreateProductParams): Promise<SaveResult> {
  try {
    if (!productData.name) {
      throw new Error('Le nom du produit est obligatoire');
    }
    
    if (!organizationId) {
      throw new Error("L'ID d'organisation est obligatoire");
    }
    
    console.log("Création d'un nouveau produit avec ID d'organisation:", organizationId, "et ID de boutique:", shopId);
    console.log("Création d'un produit avec form_id:", productData.form_id);
    
    // Créer un objet de données produit propre pour éviter toute référence circulaire
    const cleanProductData: Partial<Product> = {
      name: productData.name,
      overview: productData.overview,
      description: productData.description,
      price: productData.price,
      discount_price: productData.discount_price,
      sku: productData.sku,
      stock_quantity: productData.stock_quantity,
      is_stock_managed: productData.is_stock_managed,
      media_urls: productData.media_urls,
      category: productData.category,
      benefits: productData.benefits,
      faqs: productData.faqs,
      low_stock_threshold: productData.low_stock_threshold,
      weight: productData.weight,
      dimensions: productData.dimensions,
      tags: productData.tags,
      is_visible: productData.is_visible,
      status: productData.status,
      currency: productData.currency,
      shop_id: shopId,
      organization_id: organizationId,
      form_id: productData.form_id
    };
    
    console.log("Données du produit prêtes à envoyer à addProduct:", {
      name: cleanProductData.name,
      price: cleanProductData.price,
      shop_id: cleanProductData.shop_id,
      organization_id: cleanProductData.organization_id,
      form_id: cleanProductData.form_id
    });
    
    // Utiliser la fonction addProduct
    const result = await addProduct(cleanProductData, organizationId, shopId);
    
    if (result) {
      console.log("Produit créé avec succès:", result);
      return { success: true, productId: result.id };
    } else {
      console.error("La création du produit a échoué - aucun résultat renvoyé");
      throw new Error('Échec de la création du produit');
    }
  } catch (error) {
    console.error("Erreur lors de la création du produit:", error);
    return { success: false, error: error instanceof Error ? error : new Error('Erreur inconnue') };
  }
}
